export const decodeQueryParams = <T = Record<string, string | string[]>>(query: string) => {
  const entries = new URLSearchParams(query).entries();

  const result: Record<string, unknown> = {};

  for (const [key, value] of entries) {
    if (result[key]) {
      if (!Array.isArray(result[key])) {
        result[key] = [result[key]];
      }

      (result[key] as string[]).push(value);
    } else {
      result[key] = value;
    }
  }

  return result as T;
};
